import { render, staticRenderFns } from "./AddOrganization.vue?vue&type=template&id=308e85be&"
import script from "./AddOrganization.vue?vue&type=script&lang=js&"
export * from "./AddOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AddOrganization.vue?vue&type=style&index=0&id=308e85be&prod&lang=scss&"
import style1 from "./AddOrganization.vue?vue&type=style&index=1&id=308e85be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports